import { request } from '@/request/request';
import { parameterChange } from '@/utils';

const prefix = `${process.env.VUE_APP_OU_PREFIX}/improve_plan`;

// 专项计划管理
export default {
  improvePlanPageList(data) {
    return request({ url: `${prefix}/planPageList?${parameterChange(data)}`, method: 'get', data });
  },
  improvePlanDetail(data) {
    return request({ url: `${prefix}/planDetail?${parameterChange(data)}`, method: 'get', data });
  },
  improvePlanAdd(data) {
    return request({ url: `${prefix}/planAdd`, method: 'post', data });
  },
  improvePlanUpdate(data) {
    return request({ url: `${prefix}/planUpdate`, method: 'post', data });
  },
  improvePlanDelete(data) {
    return request({ url: `${prefix}/planDelete`, method: 'post', data });
  },
  improveStageSave(data) {
    return request({ url: `${prefix}/stageSave`, method: 'post', data });
  },
  improveAssessmentSave(data) {
    return request({ url: `${prefix}/assessmentSave`, method: 'post', data });
  },
  improveRecordPageList(data) {
    return request({ url: `${prefix}/recordPageList?${parameterChange(data)}`, method: 'get', data });
  },
  improveRefOptions(data) {
    return request({ url: `${prefix}/refOptions?${parameterChange(data)}`, method: 'get', data });
  },
};
